import { FiltersKeyType } from '../../keys';

const filtersKeys: FiltersKeyType = {
  booleanOptions: {
    any: 'any',
    false: 'false',
    true: 'true'
  },
  dateOptions: {
    exactDay: 'exact day',
    equals: 'Equals',
    notEquals: 'Does not equal',
    before: 'Before',
    after: 'After',
    between: 'Between',
    blank: 'Blank',
    notBlank: 'Not blank',
    numberOfDaysAgo: 'number of days ago',
    numberOfDaysFromNow: 'number of days from now',
    oneMonthAgo: 'one month ago',
    oneMonthFromNow: 'one month from now',
    oneWeekAgo: 'one week ago',
    oneWeekFromNow: 'one week from now',
    theNextMonth: 'the next month',
    theNextNumberOfDays: 'the next number of days',
    theNextWeek: 'the next week',
    theNextYear: 'the next year',
    thePastMonth: 'the past month',
    thePastNumberOfDays: 'the past number of days',
    thePastWeek: 'the past week',
    thePastYear: 'the past year',
    thisCalendarMonth: 'this calendar month',
    thisCalendarWeek: 'this calendar week',
    thisCalendarYear: 'this calendar year',
    today: 'today',
    tomorrow: 'tomorrow',
    yesterday: 'yesterday'
  },
  datePresets: {
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last3Months: 'Last 3 months',
    last12Months: 'Last 12 months',
    moreThan7DaysAgo: 'More than 7 days ago',
    moreThan30DaysAgo: 'More than 30 days ago',
    moreThan3MonthsAgo: 'More than 3 months ago',
    moreThan12MonthsAgo: 'More than 12 months ago',
    thisWeek: 'This week',
    thisMonth: 'This month',
    thisYear: 'This year'
  },
  enterDays: 'Enter days',
  enterFilterName: 'Enter filter name',
  saveCurrentFilters: 'Save current filters',
  numberOptions: {
    equals: 'Equals',
    notEquals: 'Does not equal',
    between: 'Between',
    blank: 'Blank',
    notBlank: 'Not blank',
    greaterThan: 'Greater than',
    lessThan: 'Less than',
    greaterThanOrEqual: 'Greater than or equal to',
    lessThanOrEqual: 'Less than or equal to'
  },
  textOptions: {
    contains: 'Contains',
    notContains: 'Does not contain',
    equals: 'Equals',
    notEquals: 'Does not equal',
    startsWith: 'Starts with',
    endsWith: 'Ends with',
    blank: 'Blank',
    notBlank: 'Not blank'
  },
  users: {
    containsAnyOf: 'Contains any of',
    doesNotContainAnyOf: "Doesn't contain any of",
    isEmpty: 'Is empty',
    isNotEmpty: 'Is not empty'
  },
  modes: {
    contains: 'contains',
    containsAllOf: 'contains all of',
    containsAnyOf: 'contains any of',
    containsNoneOf: 'contains none of',
    containsOnly: 'contains only',
    doesNotContainAnyOf: "doesn't contain any of",
    endsWith: 'ends with',
    is: 'is',
    isAfter: 'is after',
    isAnyOf: 'is any of',
    isBefore: 'is before',
    isEmpty: 'is empty',
    isNoneOf: 'is none of',
    isNot: 'is not',
    isNotEmpty: 'is not empty',
    isOnOrAfter: 'is on or after',
    isOnOrBefore: 'is on or before',
    isWithin: 'is within',
    startsWith: 'starts with',
    greaterThanEqual: 'greater than equal',
    lessThanEqual: 'less than equal'
  }
};

export default filtersKeys;
